import './style.scss'
import {
  PopupManager
} from 'element-ui/lib/utils/popup'
export function createTablePopover () {
  return {
    props: {
      transition: {
        type: String,
        default: 'fade-in-linear'
      },
      popperClass: String,
      content: String | HTMLElement | Object,
      visibleArrow: {
        type: Boolean,
        default: true
      },
      isTouchContent: {
        type: Boolean,
        default: false
      },
      value: {
        type: Boolean,
        default: false
      },
      width: {
        type: Number,
        default: 200
      },
      wrapClass: {
        type: String,
      },
      effect: {
        type: String,
        default: 'light'
      },
      reference: {}
    },
    render (_) {
      const { transition, popperClass, content, visibleArrow, width, value, wrapClass, effect } = this
      const effectClassName = effect === 'light' ? 'kye-plugin-popper-wrap-light' : 'kye-plugin-popper-wrap-dark'
      const className = ['kye-plugin-popper-wrap el-popper el-popover', effectClassName, wrapClass, popperClass, content && 'el-popover--plain'].filter(Boolean)
      const style = {
        width: isFinite(width) ? width + 'px' : width,
        display: value ? 'block' : 'none',
        zIndex: PopupManager && PopupManager.nextZIndex()
      }
      return <transition
        name={transition}
      >
        <div
          ref="popper"
          style={style}
          class={className}
        >
          {
            visibleArrow ? <div x-arrow class="popper__arrow"></div> : null
          }
          <div class='kye-plugin-popper-wrap-content'>{content}</div>
        </div>
      </transition>
    },
    methods: {
      disconnectObserver () {
        if (this.popoverReferenceIOInstance) {
          this.popoverReferenceIOInstance.disconnect()
          this.popoverReferenceIOInstance = null
        }
      },
      // 判断reference的可见性，不可见时，隐藏
      targetElementIntersectionObserver (targetElement) {
        if (!targetElement) {
          return
        }
        this.disconnectObserver()
        this.popoverReferenceIOInstance = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              // 元素不在可视区域内,则隐藏
              this.value = false
            }
          })
        }, {
          threshold: 0, // 可视区域的阈值，0表示只要有一点进入可视区域则会 entry.isIntersecting等于true反之false 1表示整体显示在可视区域
        }) // 设置交叉阈值为 50%
        // 开始观察
        this.popoverReferenceIOInstance.observe(targetElement)
      },
      // 移除载体的事件监听
      removeHandleEvent () {
        const reference = this.$props.reference
        if (reference) {
          reference.removeEventListener('mouseleave', this.handleMouseLeave)
          reference.removeEventListener('mouseenter', this.handleMouseEnter)
        }
        if (this.$props.isTouchContent) {
          const popper = this.$refs.popper
          popper && popper.removeEventListener('mouseleave', this.handleMouseLeave)
          popper && popper.removeEventListener('mouseenter', this.handleMouseEnter)
        }
        this.disconnectObserver()
      },
      // 气泡内容和载体的事件监听
      handleEvent () {
        const reference = this.$props.reference
        const popper = this.$refs.popper
        this.$nextTick(() => {
          if (reference) {
            reference.addEventListener('mouseenter', this.handleMouseEnter)
            reference.addEventListener('mouseleave', this.handleMouseLeave)
            this.targetElementIntersectionObserver(reference)
          }
          if (this.$props.isTouchContent) {
            popper.addEventListener('mouseenter', this.handleMouseEnter)
            popper.addEventListener('mouseleave', this.handleMouseLeave)
          }
        })
      },
      clearTimerTimeout() {
        clearTimeout(this._timer)
      },
      // 移入气泡时隐藏，并清除定时器
      handleMouseEnter() {
        clearTimeout(this._timer)
        this.value = true
      },
      // 移出气泡或载体时，异步关闭。为了增在移除载体时，移入气泡时，搭配handleMouseEnter 不被关闭
      handleMouseLeave() {
        clearTimeout(this._timer)
        this._timer = setTimeout(() => {
          this.value = false
        }, 200)
      },
    },
    beforeDestroy () {
      // 销毁监听的事件
      this.removeHandleEvent()
    }
  }
}




// WEBPACK FOOTER //
// ./src/public/plugins/popover/component.js